var exports = {
  "S": "xcc377c0b--01af52--image",
  "i": "xcc377c0b--01af52--image-container",
};

module.exports = exports;
